import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Theme from "../../../../../../styles/Theme/Theme";
import Button from "../../../../Atomics/Button";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import { Text } from "../../../../Atomics/Text";
import FamilyTypeFilter from "../Filters/FamilyTypeFilter/FamilyTypeFilter";

const FiltersContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: end;
    gap: 100px;
    margin-bottom: 40px;
    `;
const SelectContainer = styled.div`
    width: 400px;
`;
const LabelContainer = styled.label`
    font-weight: 500;
    display: flex;
    align-items: center;
    height: 35px;
    gap: 20px;
    justify-content: space-between;
`;

const ItemsFilter = ({ tenantOptions, selectedTenant, setSelectedTenant, familyOptions, typeOptions, selectedFilter, setSelectedFilter,
    isTenantFilterDisabled, isFilterDisabled, isApplyButtonDisabled, onApplyFilters
}) => {

    const { t } = useTranslation();

    const formatOptions = (options) => {
        if (!options) return [];
        return options.map(option => {
            return {
                value: option,
                label: option
            }
        });
    }

    return (
        <>
            <FiltersContainer>
                <SelectContainer>
                    <LabelContainer>
                        <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium'>{t('Tenant')}</Text>
                    </LabelContainer>

                    <SelectAtomic
                        optionsData={formatOptions(tenantOptions)}
                        fullWidth={true}
                        defaultValue={selectedTenant}
                        handleOptionsChange={(value) => {
                            setSelectedTenant(value)
                        }}
                        isToDisable={isTenantFilterDisabled}
                        placeholder={
                            <span style={{ color: "lightgrey" }}>
                                {t("Select Tenant")}
                            </span>
                        }
                    />

                </SelectContainer>
                <FamilyTypeFilter
                    familyOptions={formatOptions(familyOptions)}
                    typeOptions={formatOptions(typeOptions)}
                    isFilterDisabled={isFilterDisabled}
                    isForModal={false}
                    selectedFilter={selectedFilter}
                    setSelectedFilter={setSelectedFilter}
                    isDefaultSelectionRequired={true}
                    width={"400px"}
                />

            </FiltersContainer>
            <Flex align="center" justify="center">
                <Button
                    $backgroundColor={Theme.color["blue-4"]}
                    size="xs"
                    $color="white"
                    width="10%"
                    style={{ fontWeight: '500' }}
                    onClick={onApplyFilters}
                    disabled={isApplyButtonDisabled}
                >
                    {t("apply")}
                </Button>
            </Flex>
        </>
    )
};

export default ItemsFilter;